class Monitoring.Models.SourceIcon

  constructor: ->
    @icons = {
      facebook:                     'facebook-social-icon',
      twitter:                      'twitter-social-icon',
      instagram:                    'instagram-social-icon',
      instagram_business_account:   'instagram-social-icon',
      instagram_dm:                 'instagram-social-icon',
      youtube:                      'youtube-social-icon',
      email:                        'envelope-social-icon',
      webchat:                      'comments-social-icon',
      whatsapp:                     'whatsapp-social-icon',
      whatsapp_wavy:                'whatsapp-social-icon',
      whatsapp_business:            'whatsapp-social-icon',
      google_play:                  'google-play-social-icon',
      google_search:                'google-social-icon',
      google_my_business:           'google-my-business-social-icon',
      appstore:                     'app-store-social-icon',
      apple_app_store:              'app-store-social-icon',
      adwords:                      'google-social-icon',
      twitterads:                   'twitter-social-icon',
      facebookads:                  'facebook-social-icon',
      clipping:                     'paperclip-social-icon',
      linkedin:                     'linkedin-social-icon',
      tiktok:                       'tiktok-social-icon'
    }
    @names = {
      facebookads:                  'Facebook',
      facebook:                     'Facebook',
      twitter:                      'Twitter',
      twitterads:                   'Twitter',
      instagram:                    'Instagram',
      instagram_business_account:   'Instagram',
      instagram_dm:                 'Instagram',
      whatsapp:                     'WhatsApp',
      whatsapp_wavy:                'WhatsApp',
      whatsapp_business:            'WhatsApp',
      webchat:                      'WebChat',
      youtube:                      'YouTube',
      email:                        'Mail',
      appstore:                     'App&nbsp;Store',
      apple_app_store:              'App&nbsp;Store',
      clipping:                     'Clipping',
      linkedin:                     'LinkedIn',
      google_play:                  'Google&nbsp;Play',
      google_search:                'Google&nbsp;Search',
      google_my_business:           'Google&nbsp;My&nbsp;Business',
      adwords:                      'AdWords',
      tiktok:                       'TikTok'
    }

  sourcePrettyName: (source) =>
    @names[source] || 'other'

  sortedProviderNames: () ->
    _.uniq([''].concat(_.values(@names)))

  sourceIcon: (source) =>
    if @icons[source] != undefined
      @icons[source]
    else
      ""

